import { Box, Heading, Paragraph } from 'grommet'
import styled from 'styled-components'

import { TitleProps, WrapperProps } from './types'

export const Wrapper = styled(Box)<WrapperProps>`
  margin-bottom: ${({ theme }) => theme.spaces[4]}px;

  ${({ wrapperAdditionalStyles }) => wrapperAdditionalStyles}
`

export const Title = styled(Heading)<TitleProps>`
  ${({ theme }) => theme.getTypography('desktop', 'title', 'title1')}

  color: ${({ theme }) => theme.newColors.primary};
  margin-bottom: ${({ theme }) => theme.spaces[3]}px;
  text-transform: none;
  width: 100%;

  ${({ theme }) => theme.below.mobileL`
    ${theme.getTypography('mobile', 'title', 'title2')}
  `}

  ${({ titleAdditionalStyles }) => titleAdditionalStyles}
`

export const Subtitle = styled(Paragraph)`
  ${({ theme }) => theme.getTypography('desktop', 'body', 'body2')}

  color: ${({ theme }) => theme.newColors.darkGray};
  max-width: 100%;
  text-align: justify;
  white-space: pre-wrap;

  ${({ theme }) => theme.below.tablet`
    text-align: initial;
  `}

  ${({ theme }) => theme.below.mobileL`
    ${theme.getTypography('mobile', 'body', 'body2')}
  `}
`
